module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-dark do-calendar__wrapper",
    class: {
      'do-calendar__wrapper--dragging': _vm.isDragging
    }
  }, [(_vm.isDeviceMobile) ? _c('div', {
    ref: "do_calendar_frontend_lock",
    staticClass: "do-calendar-frontend-lock",
    on: {
      "click": _vm.setIsLockedFromFrontend
    }
  }, [_c('div', {
    staticClass: "do-calendar-frontend-lock__inner"
  }, [(_vm.isLockedFromFrontend) ? _c('span', {
    staticClass: "icon-lock5"
  }) : _c('span', {
    staticClass: "icon-unlocked2"
  })])]) : _vm._e(), _vm._v(" "), _c('week-selector', {
    attrs: {
      "startDate": _vm.weekSelectorStartDate,
      "endDate": _vm.weekSelectorEndDate,
      "date": _vm.activeCalendarDate
    },
    on: {
      "changed": _vm.setDate
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "printCalendar"
    }
  }, [_c('div', {
    staticClass: "d-calendar do-calendar"
  }, [_c('div', {
    staticClass: "d-calendar__header do-calendar__header",
    staticStyle: {
      "min-height": "54px"
    }
  }, [(_vm.calendar) ? _c('DCalendarHeader', {
    attrs: {
      "isLoadingEvents": _vm.isEventsLoading,
      "activeCalendarDate": _vm.activeCalendarDate,
      "calendarId": _vm.theActiveCalendarId,
      "initCalendar": _vm.calendar,
      "dates": _vm.calendarDates,
      "hasHotKeys": true,
      "isMultiple": _vm.userHasPermission('can_see_other_calendars')
    },
    on: {
      "updateEvents": _vm.readEvents,
      "updateCalendar": function($event) {
        return _vm.readEvents(true)
      },
      "next": _vm.nextWeek,
      "prev": _vm.prevWeek,
      "today": _vm.today,
      "copyCalendarModalOpen": function($event) {
        return _vm.setIsCopyCalendarModalOpen($event)
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "d-calendar__calendar__container",
    class: {
      'd-calendar__calendar__container--print-mode': _vm.isCalendarInPrintMode
    }
  }, [_c('DCalendar', {
    attrs: {
      "calendar": _vm.calendar,
      "isEditable": _vm.isEditable,
      "isLocked": _vm.isLocked,
      "isCalendarInPrintMode": _vm.isCalendarInPrintMode,
      "isShowWeekends": _vm.isShowWeekends,
      "startTime": _vm.startTime,
      "endTime": _vm.endTime,
      "date": _vm.activeCalendarDate,
      "events": _vm.dCalendarEvents,
      "calendarId": _vm.theActiveCalendarId,
      "calendarName": _vm.calendarName,
      "firstDayOfWeek": _vm.firstDayOfWeek,
      "isEventsClickable": true,
      "isAbsenceEditable": _vm.getIsAbsenceEditable,
      "isCopyCalendarModalOpen": _vm.isCopyCalendarModalOpen
    },
    on: {
      "onEventClick": _vm.setActiveEvent,
      "dates": _vm.setCalendarDates,
      "onDragging": _vm.setIsDragging
    }
  })], 1)]), _vm._v(" "), (_vm.isShowWeekPlan) ? _c('DWeekplan', {
    attrs: {
      "isInPrintMode": _vm.isInPrintMode,
      "isReadOnly": _vm.isInPrintMode || !_vm.userHasPermission('can_edit_own_notes')
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "zoomIn"
    }
  }, [(_vm.activeEvent) ? _c('DCalendarShowEvent', {
    attrs: {
      "isDCalendarInROR": true,
      "canEditEvent": true,
      "canEditNotes": _vm.userHasPermission('can_edit_own_notes'),
      "event": _vm.activeEvent,
      "calendar": _vm.calendar,
      "initCalendarId": _vm.theActiveCalendarId,
      "isInDCalendar": true
    },
    on: {
      "updated": _vm.readEvents,
      "close": _vm.closeShowEvent,
      "submitDeleteEventOnward": function($event) {
        return _vm.readEvents(true)
      }
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-13e1ed8c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Calendars/DoCalendar.vue
// module id = 1464
// module chunks = 1